<template>

    <section class="c-visit_list">
        <header class="c-visit_list__header">
            <h3 class="c-visit_list__header-title">
                Wizyty dotyczące problemu: <span class="c-visit_list__issue">{{ issue.name }}</span>
            </h3>
            <div class="c-visit_list__header-actions">
                <v-btn
                    type="icon"
                    icon="edit"
                    title="Edytuj problem"
                    @click="$refs.issueEditModal.$emit('open', issue)">
                </v-btn>
                <v-btn
                    type="icon"
                    icon="delete"
                    title="Usuń problem"
                    @click="$refs.issueRemoveModal.$emit('open', issue.id)">
                </v-btn>
            </div>
        </header>
        <v-table>
            <thead>
            <th>Data</th>
            <th>Godzina</th>
            <th>Typ wizyty</th>
            <th>Lokalizacja</th>
            <th>Status wizyty</th>
            <th v-if="p1IntegrationActive">Raportowanie do P1</th>
            <th>Dostępne akcje</th>
            </thead>
            <tbody ref="tbody">
            <tr
                v-for="(visit, index) in visits.data"
                :key="index">
                <td>{{ visit.date }}</td>
                <td>{{ visit.hours }}</td>
                <td>{{ visit.type }}</td>
                <td>{{ visit.location }}</td>
                <td><span class="c-visit_list__status-success">{{ visit.status }}</span></td>
                <td class="tooltip-td" v-if="p1IntegrationActive">
                    <div class="tooltip" @click="$refs.visitP1ReportsModal.$emit('open', visit)">
                        <span class="c-visit_list__status-pending" v-if="!visit.p1_report_status">Jeszcze nie przesłano</span>
                        <span class="c-visit_list__status-pending" v-if="visit.p1_report_status === 'pending'">Oczekuje</span>
                        <span class="c-visit_list__status-pending" v-if="visit.p1_report_status === 'started'">Przesyłanie...</span>
                        <span class="c-visit_list__status-success" v-if="visit.p1_report_status === 'finished'">Przesłano</span>
                        <span class="c-visit_list__status-error" v-if="visit.p1_report_status === 'error'">Błąd</span>
                        <span class="tooltiptext">{{ visit.p1_report_status ? (visit.p1_report_info + ' Kliknij aby uzyskać więcej informacji.') : 'Wizyta zostanie przesłana po jej zakończeniu.' }} </span>
                        <div
                            class="p1-report-details-button"
                            :class="visit.p1_report_status"
                            title="Sprawdź szczegóły raportowania"
                            v-if="visit.p1_report_status"
                            @click="$refs.visitP1ReportsModal.$emit('open', visit)">
                        </div>
                    </div>
                </td>
                <td>
                    <div class="c-visit_list__table-actions">
                        <v-btn
                            class="c-visit_list__btn"
                            type="green"
                            size="small"
                            :to="{ name: 'PatientVisitEdit', params: { id: patient.id, id1: visit.id } }">
                            {{ visit.actionLabel }}
                        </v-btn>
                        <v-btn
                            type="icon"
                            icon="delete"
                            title="Usuń wizytę"
                            @click="$refs.visitRemoveModal.$emit('open', visit.id)">
                        </v-btn>
                    </div>
                </td>
            </tr>
            </tbody>
            <v-loader
                :loading="isFetching"
                :bind-to="$refs.tbody">
            </v-loader>
        </v-table>
        <p class="c-visit_list__empty" v-if="visits.data.length === 0">Brak wizyt</p>

        <issue-remove-modal
            ref="issueRemoveModal"
            @ok="removeIssue">
        </issue-remove-modal>
        <issue-edit-modal
            ref="issueEditModal"
            @ok="editIssue">
        </issue-edit-modal>
        <visit-remove-modal
            ref="visitRemoveModal"
            @ok="removeVisit">
        </visit-remove-modal>
        <visit-p1-reports-modal
            ref="visitP1ReportsModal"
            @ok="">
        </visit-p1-reports-modal>
    </section>

</template>


<script>

import {mapGetters} from 'vuex'
import VBtn from 'Components/VBtn'
import VTable from 'Components/VTable'
import IssueRemoveModal from 'Components/Issue/IssueRemoveModal'
import VisitRemoveModal from 'Components/Visit/VisitRemoveModal'
import VisitP1ReportsModal from 'Components/Visit/VisitP1ReportsModal'
import IssueEditModal from 'Components/Issue/IssueEditModal'
import VLoader from 'Components/VLoader'

export default {

    name: 'PatientVisits',

    data() {
        return {
            isFetching: false,
            refreshInterval: null,
        }
    },

    computed: {
        ...mapGetters('visits', ['visits', 'issue', 'patient']),
        p1IntegrationActive() {
            return this.$auth.user().p1_integration_settings && this.$auth.user().p1_integration_settings.integration_enabled
        }
    },

    methods: {
        removeVisit(visitId, closeModal) {
            this.$store.dispatch('visits/REMOVE_VISIT', visitId).then(({data}) => {
                this.$alert.success('Usuwanie wizyty', data.message)
                closeModal()
            }).catch((error) => {
                this.$alert.error('Usuwanie wizyty', error.response.data.message)
                closeModal()
            })
        },
        editIssue(issue, closeModal) {
            this.$store.dispatch('visits/UPDATE_ISSUE', issue).then(({data}) => {
                this.$alert.success('Edycja problemu', data.message)
                closeModal()
            }).catch((error) => {
                this.$alert.error('Edycja problemu', error.response.data.message)
                closeModal()
            })
        },
        removeIssue(issueId, closeModal) {
            this.$store.dispatch('visits/REMOVE_ISSUE', issueId).then(({data}) => {
                closeModal()
                this.$router.push({name: 'PatientShow', params: this.$route.params})
            }).catch((error) => {
                this.$alert.error('Usuwanie problemu', error.response.data.message)
                closeModal()
            })
        },
        checkAndRefreshVisits() {
            if (this.visits.data.some(visit => visit.p1_report_status === 'started' || visit.p1_report_status === 'pending')) {
                if (!this.refreshInterval) {
                    this.refreshInterval = setInterval(() => {
                        this.fetchVisits(false);
                    }, 3000);
                }
            } else if (this.refreshInterval) {
                clearInterval(this.refreshInterval);
                this.refreshInterval = null;
            }
        },
        fetchVisits(usingIsFetching = true) {
            if (usingIsFetching) {
                this.isFetching = true
            }
            this.$store.dispatch('visits/FETCH_VISITS', {
                issueId: this.$route.query.issue_id,
                page: this.$route.query.page
            }).then(() => {
                if (usingIsFetching) {
                    this.isFetching = false
                }
            })
        },
    },

    watch: {
        '$route.query.page'() {
            this.fetchVisits();
        },
        'visits.data': function() {
            this.checkAndRefreshVisits();
        },
    },

    mounted() {
        this.checkAndRefreshVisits();
    },

    beforeDestroy() {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }
    },

    components: {
        VBtn,
        VTable,
        IssueRemoveModal,
        VisitRemoveModal,
        VisitP1ReportsModal,
        IssueEditModal,
        VLoader
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-visit_list {
    &__issue {
        color: $c-secondary;
    }
    &__status-pending {
        font-weight: 800;
        color: $c-secondary;
        cursor: default;
    }
    &__status-success {
        font-weight: 800;
        color: $c-primary;
        cursor: default;
    }
    &__status-error {
        font-weight: 800;
        color: $c-red;
        cursor: default;
    }
    &__btn {
        width: 10rem;
    }
    &__header {
        display: flex;
        justify-content: space-between;


        &-actions {
            padding-left: 1rem;
            flex-shrink: 0;
        }
    }
    &__table-actions {
        display: flex;
        width: 100%;
        justify-content: flex-end;
        flex-shrink: 0;

        span {
            margin-right: 0.5rem;

            &:last-child {
                margin-right: 0;
            }
        }
    }
    &__empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 1.2rem;
        margin: 2rem 0;
        width: 100%;
        text-align: center;
    }
    .tooltip-td {
        overflow: visible;
    }
    .tooltip {
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;

        span {
            cursor: pointer;
            user-select: none;
        }
    }
    .tooltip .tooltiptext {
        visibility: hidden;
        background-color: $c-secondary;
        color: #fff;
        border-radius: 6px;
        position: absolute;
        z-index: 1;
        top: 50%;
        right: calc(100% + 10px);
        transform: translateY(-50%);
        font-size: 10px;
        width: 240px;
        text-align: left;
        padding: 5px;
        text-wrap: wrap;
    }
    .tooltip .tooltiptext::after {
        content: "";
        position: absolute;
        top: 50%;
        right: -10px; /* Dostosowano do 10px, aby strzałka była widoczna */
        margin-top: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent transparent transparent $c-secondary; /* Zapewnia, że strzałka jest koloru $c-secondary */
    }
    .tooltip:hover .tooltiptext {
        visibility: visible;
    }

    .p1-report-details-button {
        background-color: $c-primary;
        -webkit-mask-image: url('#{$icons}/info.svg');
        mask-image: url('#{$icons}/info.svg');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 50% 50%;
        padding: 0;
        width: 20px;
        height: 20px;
        cursor: pointer;
        user-select: none;
        display: inline-block;
        margin-left: 5px;

        &.pending,
        &.started {
            background-color: $c-secondary;
        }

        &.finish {
            background-color: $c-primary;
        }

        &.error {
            background-color: $c-red;
        }
    }
}

</style>
